<div class="feedback-card">
  <div class="contents">
    <div class="prompt-wrapper">
      <app-icon class="feedback-icon" [icon]="megaphoneIcon"> </app-icon>

      <div class="prompt">
        <h4 class="title">
          {{ feedbackCard?.titleKey | translate }}
        </h4>

        <p class="description">
          {{ feedbackCard?.descriptionKey | translate }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="cta"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="giveFeedbackTrackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (click)="openFeedbackDialog()"
    >
      {{ 'ACTION.SEND_FEEDBACK' | translate }}
    </button>
  </div>

  <button
    type="button"
    class="close-action"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="dismissTrackingAction"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    (click)="closeFeedbackCard()"
  >
    <app-icon class="close-icon" [icon]="closeIcon"> </app-icon>
  </button>
</div>

<app-feedback-dialog
  [feedbackScreenName]="feedbackScreenName"
  [accountId]="accountId"
  [settings]="settings"
  [currentPlan]="currentPlan"
  [userEmail]="userEmail"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject"
>
</app-feedback-dialog>
